var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadyToGo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9016 13.1071L12.7985 23.0456",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7354 17.6826V8.53157C21.7354 8.39462 21.6989 8.26012 21.6295 8.14184C21.5602 8.02355 21.4605 7.92571 21.3407 7.85832L13.1809 3.26868C13.0642 3.20306 12.9325 3.16858 12.7985 3.16858C12.6645 3.16858 12.5327 3.20306 12.4161 3.26868L4.25625 7.85832C4.13644 7.92571 4.03676 8.02355 3.96741 8.14184C3.89806 8.26012 3.86151 8.39462 3.86151 8.53157V17.6826C3.86151 17.8196 3.89806 17.9541 3.96741 18.0724C4.03676 18.1906 4.13644 18.2885 4.25625 18.3559L12.4161 22.9455C12.5327 23.0111 12.6645 23.0456 12.7985 23.0456C12.9325 23.0456 13.0642 23.0111 13.1809 22.9455L21.3407 18.3559C21.4605 18.2885 21.5602 18.1906 21.6295 18.0724C21.6989 17.9541 21.7354 17.8196 21.7354 17.6826V17.6826Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.629 8.14096L12.9016 13.1071L3.96863 8.13989",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5714 15.0898V10.4497L8.55878 5.43823",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyToGo);
export default __webpack_public_path__ + "static/media/ready-to-go.8c286bbc0a26f16b00e4e3c9120848eb.svg";
export { ForwardRef as ReactComponent };